import React, { useContext } from 'react'
import formStyles from 'styles/form.module.scss'
import { Field } from 'react-final-form'
import DeviceId from 'utils/detectDevice'
import { required, inputHasErr, composeValidators } from 'utils/validations'
import { FormDataContext } from 'providers/FormData'
import Dropdown from 'react-dropdown'
import SelectGroupedOptions from 'components/common/SelectGroupedOptions'

import { getMotherTongueDropdownOptions } from 'api/transformers'

const MotherTongue = ({ domainLanguage }) => {
  const { formData, loading } = useContext(FormDataContext)
  const motherTongueOptions = getMotherTongueDropdownOptions(
    formData.motherTongues
  )
  return (
    !loading && (
      <div className="form-row">
        <label className={`${formStyles.label} col-md-12`}>Mother tongue</label>
        <Field
          name="mother_tongue"
          validate={composeValidators(required('mother_tongue'))}
        >
          {({ input, meta }) => (
            <div className="col-md-12">
              {DeviceId.isDesktop() && (
                <Dropdown
                  controlClassName="mother_tongue_selector"
                  menuClassName="mother_tongue_options"
                  options={motherTongueOptions}
                  value={domainLanguage}
                  placeholder={domainLanguage}
                  className={`${inputHasErr(meta) && formStyles.inputError}`}
                  disabled={domainLanguage !== 'Select'}
                  {...input}
                />
              )}
              {DeviceId.isMobile() && (
                <select
                  data-testid="mother_tongue_selector"
                  className={`form-control ${inputHasErr(meta) &&
                    formStyles.inputError} ${formStyles.selectMobile}`}
                  {...input}
                  disabled={domainLanguage !== 'Select'}
                >
                  <option value={domainLanguage} hidden>
                    {domainLanguage}
                  </option>
                  <SelectGroupedOptions optionsData={motherTongueOptions} />
                </select>
              )}
              {meta.touched && meta.error && (
                <span
                  data-testid="mother_tongue_error"
                  className={formStyles.error}
                >
                  {meta.error}
                </span>
              )}
            </div>
          )}
        </Field>
      </div>
    )
  )
}

export default MotherTongue
